<script>
import { uniqBy, orderBy, filter, isEmpty } from 'lodash';
import rbxComboboxMixin from './rbxComboboxMixin';

export default {
  mixins: [rbxComboboxMixin],
  props: {
    selected: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedItem: {},
    };
  },
  computed: {
    mergedList() {
      const list = [this.selectedItem, ...this.items];
      const removedEmptyItems = filter(list, item => !isEmpty(item)); // Because selected can be empty object

      return orderBy(uniqBy(removedEmptyItems, 'id'), 'id');
    },
  },
  watch: {
    selected() {
      this.selectedItem = this.selected;
    },
  },
  mounted() {
    this.selectedItem = this.selected;
  },
  methods: {
    updateSelection() {
      if (this.clearable && !this.selectedItem) {
        this.$emit('input', null);
      } else if (this.selectedItem) {
        const { id, translatedName } = this.selectedItem;
        this.$emit('input', { id, translatedName });
      } else {
        this.$emit('input', null);
      }
    },
  },
};
</script>

<template>
  <v-autocomplete v-model="selectedItem"
                  :disabled="disabled"
                  :items="mergedList"
                  :loading="isLoading"
                  :search-input.sync="search"
                  :allow-overflow="false"
                  :label="label"
                  @input="updateSelection"
                  item-value="id"
                  :error-messages="errorMessages"
                  :item-text="itemText"
                  height="22"
                  dense
                  :no-filter="searchable"
                  no-data-text="Keine Einträge vorhanden!"
                  return-object>
    <template slot="selection"
              slot-scope="{ item, index }">
      <span class="caption">{{ item[itemText] | truncate }} </span>
    </template>

    <template slot="item"
              slot-scope="{ item }">
      <span class="caption">{{ item[itemText] }} </span>
    </template>
  </v-autocomplete>
</template>
